var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step3" }, [
    _c(
      "div",
      { staticClass: "select-con" },
      [
        _c("div", { staticClass: "mb-2" }, [
          _vm._v("Select Ship-TO for Order:")
        ]),
        _vm._v(" "),
        _c("model-select", {
          attrs: {
            options: _vm.options,
            placeholder: "Please select allocation address"
          },
          model: {
            value: _vm.selectValue,
            callback: function($$v) {
              _vm.selectValue = $$v
            },
            expression: "selectValue"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-con" },
      [
        _c("CButton", {
          attrs: { color: "green", text: "Next", disabled: _vm.nextDisabled },
          on: { click: _vm.onNextClick }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml20" },
          [
            _c("CButton", {
              attrs: { color: "orange", text: "Back" },
              on: { click: _vm.onBack }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml20" },
          [
            _c("CButton", {
              attrs: { color: "red", text: "Cancel" },
              on: { click: _vm.onCancel }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }